var _objectSpread = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/objectSpread2.js").default;

var _objectWithoutProperties = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/objectWithoutProperties.js").default;

var _toConsumableArray = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;

var _slicedToArray = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/slicedToArray.js").default;

var _excluded = ["children"],
    _excluded2 = ["children"],
    _excluded3 = ["children"];
!function webpackUniversalModuleDefinition(e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["@wordpress/element"] = t() : (e.wp = e.wp || {}, e.wp.element = t());
}(self, function () {
  return e = {
    424: function _(e) {
      e.exports = function _interopRequireDefault(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }, e.exports.__esModule = !0, e.exports.default = e.exports;
    },
    429: function _(e, t, r) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var n = r(313);
      var o, u, i, a;
      var l = /<(\/)?(\w+)\s*(\/)?>/g;

      function createFrame(e, t, r, n, o) {
        return {
          element: e,
          tokenStart: t,
          tokenLength: r,
          prevOffset: n,
          leadingTextStart: o,
          children: []
        };
      }

      var isValidConversionMap = function isValidConversionMap(e) {
        var t = "object" == typeof e,
            r = t && Object.values(e);
        return t && r.length && r.every(function (e) {
          return (0, n.isValidElement)(e);
        });
      };

      function proceed(e) {
        var t = function nextToken() {
          var e = l.exec(o);
          if (null === e) return ["no-more-tokens"];

          var t = e.index,
              _e = _slicedToArray(e, 4),
              r = _e[0],
              n = _e[1],
              u = _e[2],
              i = _e[3],
              a = r.length;

          return i ? ["self-closed", u, t, a] : n ? ["closer", u, t, a] : ["opener", u, t, a];
        }(),
            _t = _slicedToArray(t, 4),
            r = _t[0],
            c = _t[1],
            s = _t[2],
            d = _t[3],
            f = a.length,
            p = s > u ? u : null;

        if (!e[c]) return addText(), !1;

        switch (r) {
          case "no-more-tokens":
            if (0 !== f) {
              var _a$pop = a.pop(),
                  _e2 = _a$pop.leadingTextStart,
                  _t3 = _a$pop.tokenStart;

              i.push(o.substr(_e2, _t3));
            }

            return addText(), !1;

          case "self-closed":
            return 0 === f ? (null !== p && i.push(o.substr(p, s - p)), i.push(e[c]), u = s + d, !0) : (addChild(createFrame(e[c], s, d)), u = s + d, !0);

          case "opener":
            return a.push(createFrame(e[c], s, d, s + d, p)), u = s + d, !0;

          case "closer":
            if (1 === f) return function closeOuterElement(e) {
              var _a$pop2 = a.pop(),
                  t = _a$pop2.element,
                  r = _a$pop2.leadingTextStart,
                  u = _a$pop2.prevOffset,
                  l = _a$pop2.tokenStart,
                  c = _a$pop2.children,
                  s = e ? o.substr(u, e - u) : o.substr(u);

              s && c.push(s), null !== r && i.push(o.substr(r, l - r)), i.push((0, n.cloneElement).apply(void 0, [t, null].concat(_toConsumableArray(c))));
            }(s), u = s + d, !0;

            var _t2 = a.pop(),
                _r = o.substr(_t2.prevOffset, s - _t2.prevOffset);

            _t2.children.push(_r), _t2.prevOffset = s + d;

            var _l = createFrame(_t2.element, _t2.tokenStart, _t2.tokenLength, s + d);

            return _l.children = _t2.children, addChild(_l), u = s + d, !0;

          default:
            return addText(), !1;
        }
      }

      function addText() {
        var e = o.length - u;
        0 !== e && i.push(o.substr(u, e));
      }

      function addChild(e) {
        var t = e.element,
            r = e.tokenStart,
            u = e.tokenLength,
            i = e.prevOffset,
            l = e.children,
            c = a[a.length - 1],
            s = o.substr(c.prevOffset, r - c.prevOffset);
        s && c.children.push(s), c.children.push((0, n.cloneElement).apply(void 0, [t, null].concat(_toConsumableArray(l)))), c.prevOffset = i || r + u;
      }

      var _default = function _default(e, t) {
        if (o = e, u = 0, i = [], a = [], l.lastIndex = 0, !isValidConversionMap(t)) throw new TypeError("The conversionMap provided is not valid. It must be an object with values that are WPElements");

        do {} while (proceed(t));

        return (0, n.createElement).apply(void 0, [n.Fragment, null].concat(_toConsumableArray(i)));
      };

      t.default = _default;
    },
    214: function _(e, t, r) {
      "use strict";

      var n = r(424);
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var o = {
        createInterpolateElement: !0,
        Platform: !0,
        renderToString: !0,
        RawHTML: !0
      };
      Object.defineProperty(t, "Platform", {
        enumerable: !0,
        get: function get() {
          return c.default;
        }
      }), Object.defineProperty(t, "RawHTML", {
        enumerable: !0,
        get: function get() {
          return d.default;
        }
      }), Object.defineProperty(t, "createInterpolateElement", {
        enumerable: !0,
        get: function get() {
          return u.default;
        }
      }), Object.defineProperty(t, "renderToString", {
        enumerable: !0,
        get: function get() {
          return s.default;
        }
      });
      var u = n(r(429)),
          i = r(313);
      Object.keys(i).forEach(function (e) {
        "default" !== e && "__esModule" !== e && (Object.prototype.hasOwnProperty.call(o, e) || e in t && t[e] === i[e] || Object.defineProperty(t, e, {
          enumerable: !0,
          get: function get() {
            return i[e];
          }
        }));
      });
      var a = r(942);
      Object.keys(a).forEach(function (e) {
        "default" !== e && "__esModule" !== e && (Object.prototype.hasOwnProperty.call(o, e) || e in t && t[e] === a[e] || Object.defineProperty(t, e, {
          enumerable: !0,
          get: function get() {
            return a[e];
          }
        }));
      });
      var l = r(91);
      Object.keys(l).forEach(function (e) {
        "default" !== e && "__esModule" !== e && (Object.prototype.hasOwnProperty.call(o, e) || e in t && t[e] === l[e] || Object.defineProperty(t, e, {
          enumerable: !0,
          get: function get() {
            return l[e];
          }
        }));
      });
      var c = n(r(190)),
          s = n(r(721)),
          d = n(r(369));
    },
    190: function _(e, t) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var r = {
        OS: "web",
        select: function select(e) {
          return "web" in e ? e.web : e.default;
        },
        isWeb: !0
      };
      t.default = r;
    },
    369: function _(e, t, r) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function RawHTML(e) {
        var t = e.children,
            r = _objectWithoutProperties(e, _excluded),
            o = "";

        return n.Children.toArray(t).forEach(function (e) {
          "string" == typeof e && "" !== e.trim() && (o += e);
        }), (0, n.createElement)("div", _objectSpread({
          dangerouslySetInnerHTML: {
            __html: o
          }
        }, r));
      };
      var n = r(313);
    },
    942: function _(e, t, r) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), Object.defineProperty(t, "createPortal", {
        enumerable: !0,
        get: function get() {
          return n.createPortal;
        }
      }), Object.defineProperty(t, "findDOMNode", {
        enumerable: !0,
        get: function get() {
          return n.findDOMNode;
        }
      }), Object.defineProperty(t, "render", {
        enumerable: !0,
        get: function get() {
          return n.render;
        }
      }), Object.defineProperty(t, "unmountComponentAtNode", {
        enumerable: !0,
        get: function get() {
          return n.unmountComponentAtNode;
        }
      });
      var n = r(137);
    },
    313: function _(e, t, r) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), Object.defineProperty(t, "Children", {
        enumerable: !0,
        get: function get() {
          return n.Children;
        }
      }), Object.defineProperty(t, "Component", {
        enumerable: !0,
        get: function get() {
          return n.Component;
        }
      }), Object.defineProperty(t, "Fragment", {
        enumerable: !0,
        get: function get() {
          return n.Fragment;
        }
      }), Object.defineProperty(t, "StrictMode", {
        enumerable: !0,
        get: function get() {
          return n.StrictMode;
        }
      }), Object.defineProperty(t, "Suspense", {
        enumerable: !0,
        get: function get() {
          return n.Suspense;
        }
      }), Object.defineProperty(t, "cloneElement", {
        enumerable: !0,
        get: function get() {
          return n.cloneElement;
        }
      }), t.concatChildren = function concatChildren() {
        for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
          t[r] = arguments[r];
        }

        return t.reduce(function (e, t, r) {
          return n.Children.forEach(t, function (t, o) {
            t && "string" != typeof t && (t = (0, n.cloneElement)(t, {
              key: [r, o].join()
            })), e.push(t);
          }), e;
        }, []);
      }, Object.defineProperty(t, "createContext", {
        enumerable: !0,
        get: function get() {
          return n.createContext;
        }
      }), Object.defineProperty(t, "createElement", {
        enumerable: !0,
        get: function get() {
          return n.createElement;
        }
      }), Object.defineProperty(t, "createRef", {
        enumerable: !0,
        get: function get() {
          return n.createRef;
        }
      }), Object.defineProperty(t, "forwardRef", {
        enumerable: !0,
        get: function get() {
          return n.forwardRef;
        }
      }), Object.defineProperty(t, "isValidElement", {
        enumerable: !0,
        get: function get() {
          return n.isValidElement;
        }
      }), Object.defineProperty(t, "lazy", {
        enumerable: !0,
        get: function get() {
          return n.lazy;
        }
      }), Object.defineProperty(t, "memo", {
        enumerable: !0,
        get: function get() {
          return n.memo;
        }
      }), t.switchChildrenNodeName = function switchChildrenNodeName(e, t) {
        return e && n.Children.map(e, function (e, r) {
          if ((0, o.isString)(e)) return (0, n.createElement)(t, {
            key: r
          }, e);

          var _e$props = e.props,
              u = _e$props.children,
              i = _objectWithoutProperties(_e$props, _excluded2);

          return (0, n.createElement)(t, _objectSpread({
            key: r
          }, i), u);
        });
      }, Object.defineProperty(t, "useCallback", {
        enumerable: !0,
        get: function get() {
          return n.useCallback;
        }
      }), Object.defineProperty(t, "useContext", {
        enumerable: !0,
        get: function get() {
          return n.useContext;
        }
      }), Object.defineProperty(t, "useDebugValue", {
        enumerable: !0,
        get: function get() {
          return n.useDebugValue;
        }
      }), Object.defineProperty(t, "useEffect", {
        enumerable: !0,
        get: function get() {
          return n.useEffect;
        }
      }), Object.defineProperty(t, "useImperativeHandle", {
        enumerable: !0,
        get: function get() {
          return n.useImperativeHandle;
        }
      }), Object.defineProperty(t, "useLayoutEffect", {
        enumerable: !0,
        get: function get() {
          return n.useLayoutEffect;
        }
      }), Object.defineProperty(t, "useMemo", {
        enumerable: !0,
        get: function get() {
          return n.useMemo;
        }
      }), Object.defineProperty(t, "useReducer", {
        enumerable: !0,
        get: function get() {
          return n.useReducer;
        }
      }), Object.defineProperty(t, "useRef", {
        enumerable: !0,
        get: function get() {
          return n.useRef;
        }
      }), Object.defineProperty(t, "useState", {
        enumerable: !0,
        get: function get() {
          return n.useState;
        }
      });
      var n = r(497),
          o = r(793);
    },
    721: function _(e, t, r) {
      "use strict";

      var n = r(424);
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0, t.hasPrefix = hasPrefix, t.renderAttributes = renderAttributes, t.renderComponent = renderComponent, t.renderElement = renderElement, t.renderNativeComponent = renderNativeComponent, t.renderStyle = renderStyle;
      var o = r(793),
          u = r(510),
          i = r(313),
          a = n(r(369));

      var _ref = (0, i.createContext)(void 0),
          l = _ref.Provider,
          c = _ref.Consumer,
          s = (0, i.forwardRef)(function () {
        return null;
      }),
          d = new Set(["string", "boolean", "number"]),
          f = new Set(["area", "base", "br", "col", "command", "embed", "hr", "img", "input", "keygen", "link", "meta", "param", "source", "track", "wbr"]),
          p = new Set(["allowfullscreen", "allowpaymentrequest", "allowusermedia", "async", "autofocus", "autoplay", "checked", "controls", "default", "defer", "disabled", "download", "formnovalidate", "hidden", "ismap", "itemscope", "loop", "multiple", "muted", "nomodule", "novalidate", "open", "playsinline", "readonly", "required", "reversed", "selected", "typemustmatch"]),
          m = new Set(["autocapitalize", "autocomplete", "charset", "contenteditable", "crossorigin", "decoding", "dir", "draggable", "enctype", "formenctype", "formmethod", "http-equiv", "inputmode", "kind", "method", "preload", "scope", "shape", "spellcheck", "translate", "type", "wrap"]),
          b = new Set(["animation", "animationIterationCount", "baselineShift", "borderImageOutset", "borderImageSlice", "borderImageWidth", "columnCount", "cx", "cy", "fillOpacity", "flexGrow", "flexShrink", "floodOpacity", "fontWeight", "gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart", "lineHeight", "opacity", "order", "orphans", "r", "rx", "ry", "shapeImageThreshold", "stopOpacity", "strokeDasharray", "strokeDashoffset", "strokeMiterlimit", "strokeOpacity", "strokeWidth", "tabSize", "widows", "x", "y", "zIndex", "zoom"]);

      function hasPrefix(e, t) {
        return t.some(function (t) {
          return 0 === e.indexOf(t);
        });
      }

      function isInternalAttribute(e) {
        return "key" === e || "children" === e;
      }

      function getNormalAttributeValue(e, t) {
        return "style" === e ? renderStyle(t) : t;
      }

      function getNormalAttributeName(e) {
        switch (e) {
          case "htmlFor":
            return "for";

          case "className":
            return "class";
        }

        return e.toLowerCase();
      }

      function getNormalStylePropertyName(e) {
        return (0, o.startsWith)(e, "--") ? e : hasPrefix(e, ["ms", "O", "Moz", "Webkit"]) ? "-" + (0, o.kebabCase)(e) : (0, o.kebabCase)(e);
      }

      function getNormalStylePropertyValue(e, t) {
        return "number" != typeof t || 0 === t || b.has(e) ? t : t + "px";
      }

      function renderElement(e, t) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        if (null == e || !1 === e) return "";
        if (Array.isArray(e)) return renderChildren(e, t, r);

        switch (typeof e) {
          case "string":
            return (0, u.escapeHTML)(e);

          case "number":
            return e.toString();
        }

        var n = e.type,
            d = e.props;

        switch (n) {
          case i.StrictMode:
          case i.Fragment:
            return renderChildren(d.children, t, r);

          case a.default:
            var _e3 = d.children,
                _n = _objectWithoutProperties(d, _excluded3);

            return renderNativeComponent((0, o.isEmpty)(_n) ? null : "div", _objectSpread(_objectSpread({}, _n), {}, {
              dangerouslySetInnerHTML: {
                __html: _e3
              }
            }), t, r);
        }

        switch (typeof n) {
          case "string":
            return renderNativeComponent(n, d, t, r);

          case "function":
            return n.prototype && "function" == typeof n.prototype.render ? renderComponent(n, d, t, r) : renderElement(n(d, r), t, r);
        }

        switch (n && n.$$typeof) {
          case l.$$typeof:
            return renderChildren(d.children, d.value, r);

          case c.$$typeof:
            return renderElement(d.children(t || n._currentValue), t, r);

          case s.$$typeof:
            return renderElement(n.render(d), t, r);
        }

        return "";
      }

      function renderNativeComponent(e, t, r) {
        var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
            u = "";
        if ("textarea" === e && t.hasOwnProperty("value") ? (u = renderChildren(t.value, r, n), t = (0, o.omit)(t, "value")) : t.dangerouslySetInnerHTML && "string" == typeof t.dangerouslySetInnerHTML.__html ? u = t.dangerouslySetInnerHTML.__html : void 0 !== t.children && (u = renderChildren(t.children, r, n)), !e) return u;
        var i = renderAttributes(t);
        return f.has(e) ? "<" + e + i + "/>" : "<" + e + i + ">" + u + "</" + e + ">";
      }

      function renderComponent(e, t, r) {
        var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
        var o = new e(t, n);
        "function" == typeof o.getChildContext && Object.assign(n, o.getChildContext());
        var u = renderElement(o.render(), r, n);
        return u;
      }

      function renderChildren(e, t) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            n = "";
        e = (0, o.castArray)(e);

        for (var _o = 0; _o < e.length; _o++) {
          n += renderElement(e[_o], t, r);
        }

        return n;
      }

      function renderAttributes(e) {
        var t = "";

        for (var _r2 in e) {
          var _n2 = getNormalAttributeName(_r2);

          if (!(0, u.isValidAttributeName)(_n2)) continue;

          var _o2 = getNormalAttributeValue(_r2, e[_r2]);

          if (!d.has(typeof _o2)) continue;
          if (isInternalAttribute(_r2)) continue;

          var _i = p.has(_n2);

          if (_i && !1 === _o2) continue;

          var _a = _i || hasPrefix(_r2, ["data-", "aria-"]) || m.has(_n2);

          ("boolean" != typeof _o2 || _a) && (t += " " + _n2, _i || ("string" == typeof _o2 && (_o2 = (0, u.escapeAttribute)(_o2)), t += '="' + _o2 + '"'));
        }

        return t;
      }

      function renderStyle(e) {
        if (!(0, o.isPlainObject)(e)) return e;
        var t;

        for (var _r3 in e) {
          var _n3 = e[_r3];
          null != _n3 && (t ? t += ";" : t = "", t += getNormalStylePropertyName(_r3) + ":" + getNormalStylePropertyValue(_r3, _n3));
        }

        return t;
      }

      var y = renderElement;
      t.default = y;
    },
    91: function _(e, t, r) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.isEmptyElement = void 0;
      var n = r(793);

      t.isEmptyElement = function (e) {
        return !(0, n.isNumber)(e) && ((0, n.isString)(e) || (0, n.isArray)(e) ? !e.length : !e);
      };
    },
    510: function _(e) {
      "use strict";

      e.exports = require("@wordpress/escape-html");
    },
    793: function _(e) {
      "use strict";

      e.exports = require("lodash");
    },
    497: function _(e) {
      "use strict";

      e.exports = require("react");
    },
    137: function _(e) {
      "use strict";

      e.exports = require("react-dom");
    }
  }, t = {}, r = function __webpack_require__(r) {
    var n = t[r];
    if (void 0 !== n) return n.exports;
    var o = t[r] = {
      exports: {}
    };
    return e[r](o, o.exports, __webpack_require__), o.exports;
  }(214), r;
  var e, t, r;
});